<template>
  <div>
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Submitting invoices...</p>
            </div>
        </transition>


    <b-container>
    <!-- Fake call -->
    {{getInvoices}}
        <!-- Modal for submit confirmation -->
        <b-modal  no-fade  scrollable size="l" id="modal-submitinvoices" title="Confirm Order" @ok="submitInvoices()">
            <h4>Submit Invoices?</h4>
            <ul>
            <li v-for="puborders in invoicedOrders" :key="puborders.invoicenumber">
                <strong>{{puborders.pub}}, Invoice Number: {{puborders.invoicenumber}}</strong>
            </li>
            </ul>
        </b-modal>

        <!-- Button to submit invoices -->
        <b-row style="margin-top:20px; margin-bottom:20px">
            <b-col>
                <b-button v-b-modal.modal-submitinvoices variant='warning'>SUBMIT INVOICES</b-button>
            </b-col>
        </b-row>

        <!-- Iterate over all buyers -->
        <template v-for="(puborders,index) in invoicedOrders">
            <b-row :key="puborders.pubid +'invoicen'+index"  style="margin-top:20px">
                <b-col>
                    <div style="font-size:25px; margin-top:20px">
                        Invoice # {{index+1}} of {{numberOfInvoices}}
                    </div>
                </b-col>
            </b-row>
            <!-- Names, seller address, due date -->
            <b-card :key="puborders.pubid +'seller1'+index" style="margin-top:20px" :title="'Invoice for ' + puborders.pub" border-variant="dark">
                <b-container :key="puborders.pubid +'seller2'+index" style="border-width:10px; border-color:black; margin-top:20px">

                    <b-row :key="puborders.pubid +'seller'">
                        <hr>
                        <b-col>
                            <h4 style="color:#2e5189">{{userProfile.company}}</h4>
                            {{userProfile.street1}} {{userProfile.street2}}
                            <br>
                            {{userProfile.city}}, {{userProfile.state}}, {{userProfile.zip}}
                        </b-col>
                        <b-col>
                            <h4 style="color:#2e5189">INVOICE</h4>
                            {{getTodaysDate.month}} {{getTodaysDate.date}}, {{getTodaysDate.year}}
                            <br>
                            Invoice Number: {{puborders.invoicenumber}}
                            <br>
                            DUE DATE
                            <div>
                                <b-form-datepicker :id="puborders.invoicenumber+'invoice'+index" value-as-date  v-model="puborders.duedate"></b-form-datepicker>
                            </div>

                        </b-col>
                    </b-row>
                    <!-- Buyer name and address -->
                    <b-row :key="puborders.pubid +'buyer'">
                        <b-col>
                            <h5 style="color:#2e5189">BILL TO</h5>
                            <b-form-input :id="'name'+index+puborders.pubid " v-model="puborders.pub" placeholder="Enter Name" style="margin-bottom:5px"></b-form-input>
                            <b-form-input :id="'address'+index+puborders.pubid " v-model="puborders.billingaddress" placeholder="Enter Name" style="margin-bottom:5px"></b-form-input>
                            <!-- Must change this to billing address -->
                        </b-col>
                    </b-row>

                    <!-- Invalid feedback -->
                    <b-row v-if="puborders.invalid">
                        <b-col>
                            <div style="color:red">{{invalidNumberMessage}}</div>
                        </b-col>
                    </b-row>
                    <!-- Order details -->
                    <table class="table table-bordered ">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">DATE</th>
                                <th scope="col">DESCRIPTION</th>
                                <th scope="col">QUANTITY</th>
                                <th scope="col">TAXES</th>
                                <th scope="col">AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Iterate over items for the same buyer -->
                            <tr v-for="(order, index) in puborders.orders" :key="order.suborderid">
                                <td style="width:10%; padding-top:17px"><small>{{order.orderDate}}</small></td>
                                <td style="width:50%"><b-form-input :id="'itemName'+puborders.pubid+index " v-model="order.itemName" style="margin-bottom:5px"></b-form-input></td>
                                <td style="width:10%"><b-form-input :id="'quantity'+puborders.pubid+index " v-model="order.orderQuantity" style="margin-bottom:5px"></b-form-input></td>
                                <td style="width:10%">
                                    <b-form-input :id="'tax'+puborders.pubid+index " v-model="order.tax" style="margin-bottom:5px"></b-form-input>
                                </td>
                                <td style="width:10%">
                                    <b-form-input :id="'totalCost'+puborders.pubid+index " v-model="order.totalCost" style="margin-bottom:5px"></b-form-input>
                                </td>
                            </tr>
                            <!-- Discount -->
                            <tr>
                                <td colspan="2">Discount</td>
                                <td colspan="3">
                                    <b-form-input :id="'discount'+puborders.pubid " v-model="puborders.discount"  placeholder="0" style="margin-bottom:5px"></b-form-input>
                                </td>
                            </tr>
                            <!-- Credit -->
                            <tr>
                                <td colspan="2">Credit</td>
                                <td colspan="3">
                                    <b-form-input :id="'credit'+puborders.pubid " v-model="puborders.credit" placeholder="0" style="margin-bottom:5px"></b-form-input>
                                </td>
                            </tr>
                            <!-- Deposit -->
                            <tr>
                                <td colspan="2">Deposit</td>
                                <td colspan="3">
                                    <b-form-input :id="'deposit'+puborders.pubid " v-model="puborders.deposit" placeholder="0" style="margin-bottom:5px"></b-form-input>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <!-- Total Cost -->
                    <b-row :key="puborders.pubid +'totalcost'"  v-if="!puborders.invalid">
                        <b-col></b-col>
                        <b-col>
                            <h5 style="text-align:right">TOTAL  ${{puborders.total}}</h5>
                        </b-col>
                    </b-row>
                    
                    <!-- Invalid feedback -->
                    <b-row v-if="puborders.invalid">
                        <b-col>
                            
                            <h5 style="color:red; text-align:right">TOTAL: INVALID. PLEASE ENTER ONLY NUMBERS IN TAXES AND AMOUNT</h5>
                        </b-col>
                    </b-row>
                    <hr>
                    
                    <!-- Payment instructions -->
                    <b-row :key="'instructionsheader'+puborders.pubid+index ">
                        <b-col>
                            <h5 style="padding-left:12px; ">Payment Instructions</h5>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-input :id="'instructions'+puborders.pubid+index " v-model="puborders.paymentinstructions" style="margin-bottom:5px"></b-form-input>
                        </b-col>
                    </b-row>

                </b-container>
            </b-card>
        </template>

        <!-- Button to submit invoices -->
        <b-row style="margin-top:20px; margin-bottom:200px">
            <b-col>
                <b-button v-b-modal.modal-submitinvoices variant='warning'>SUBMIT INVOICES</b-button>
            </b-col>
        </b-row>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import {timeConverterObject, copyObject} from '../Myfunctions'
const fb = require('../../firebaseConfig.js')
import {sendemailsendgriduid, sendnotification} from '../Myfunctions'

export default {    
    props: ['orders'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'invoicesArray']),

        getInvoices(){
            //Create totals
            //Iterate over all pubs
            var theInvoices=[]
            for (var i=0; i<this.invoicedOrders.length; i++){
                
                //Iterate over all orders
                var thisInvoice=this.invoicedOrders[i]
                thisInvoice.invalid=false
                thisInvoice.paid=0
                var orders=thisInvoice.orders

                //Iterate over orders in this invoice
                var total=0
                for (var j=0; j<orders.length; j++){
                    if(orders[j].totalCost&&!isNaN(orders[j].totalCost)){
                        total  = total + parseInt(orders[j].totalCost)

                    } 
                    if(orders[j].tax&&!isNaN(orders[j].tax)){
                        total  = total + parseInt(orders[j].tax)
                    } 

                    //Add invalid feedback if NaN
                    if((orders[j].totalCost&&isNaN(orders[j].totalCost))||(orders[j].tax&&isNaN(orders[j].tax))){
                        thisInvoice.invalid=true
                    } 

                }
                thisInvoice.total=total
                //End of looping across orders for this invoice
                //Get discounts, credits, deposit
                //Check valid values
                if((thisInvoice.deposit&&isNaN(thisInvoice.deposit))||(thisInvoice.discount&&isNaN(thisInvoice.discount))||(thisInvoice.credit&&isNaN(thisInvoice.credit))){
                        thisInvoice.invalid=true
                    }
                else{
                    //Get credits, discounts, deposits
                    if(thisInvoice.deposit&&!(isNaN(thisInvoice.deposit))) thisInvoice.total=thisInvoice.total+parseInt(thisInvoice.deposit)
                    if(thisInvoice.discount&&!(isNaN(thisInvoice.discount))) thisInvoice.total=thisInvoice.total-parseInt(thisInvoice.discount)
                    if(thisInvoice.credit&&!(isNaN(thisInvoice.credit))) thisInvoice.total=thisInvoice.total-parseInt(thisInvoice.credit)
                } 

                
                //Replace with object with totals
                var now = (new(Date)).getTime()
                var tomorrow = now +24*60*60*1000*30
                var tomorrowDate = new Date(tomorrow)
                thisInvoice.duedate= tomorrowDate
                theInvoices.splice(i, 1, thisInvoice)

            }
            //End of looping across invoices
            this.invoicedOrders=theInvoices
            this.numberOfInvoices=this.invoicedOrders.length
            return

        },
        
        getTodaysDate(){
            var createdOn= new Date()
            var todaydateObject = timeConverterObject(createdOn/1000)

            return todaydateObject

        },
    },

    components: {
    },

    data() {
        return {
            invoicedOrders:[],
            invalidNumberMessage:"Please enter only numbers for taxes and amount",
            performingRequest:false,
            showOrdersPlaced:false,
            numberOfInvoices:0,

        }
    },

    methods:{
        submitInvoices(){
            this.performingRequest = true

            try{
                for (var i=0; i<this.invoicedOrders.length; i++){
                    var thisInvoice=this.invoicedOrders[i]
                    //Add invoice created date
                    thisInvoice.createdOn= new Date()
                    
                    //Add payment address
                    var paymentAddress=this.userProfile.street1
                    if (this.userProfile.street2) paymentAddress = paymentAddress+' '+this.userProfile.street2
                    paymentAddress=paymentAddress+', ' +this.userProfile.city+', ' +this.userProfile.state +' '+this.userProfile.zip
                    thisInvoice.paymentaddress=paymentAddress
                    
                    //Add to invoicescollection
                    fb.invoicesCollection.add(thisInvoice)

                    //Update orders collection to show this order has been invoiced, and add invoice number
                    var theOrders=thisInvoice.orders
                    var invoicenumber=thisInvoice.invoicenumber
                    for (var j=0; j<theOrders.length; j++){
                        var thisOrder=theOrders[j]
                        var docId=thisOrder.docId
                        var updateObject={invoiced:1, invoicenumber:invoicenumber}
                        //Update only of docId
                        if(docId&&docId.length>10) fb.ordersCollection.doc(docId).update(updateObject)
                    }

                    //Send invoice email
                    console.log("Sending email to " + thisInvoice.pubid)
                    //this.sendInvoicesEmail(thisInvoice.pubid)

                    //Send app notification
                    sendnotification(thisInvoice.pubid, "New invoice from " + this.userProfile.company )
                }
                this.performingRequest = false
                this.$bvToast.toast('All invoices sent', {
                    title: 'Keg Seeker',
                    solid:true,
                    variant: 'success',
                    autoHideDelay: 5000,
                    appendToast: false
                    })
            }
            catch{
                this.performingRequest = false
                this.performingRequest = false
                this.$bvToast.toast('Error adding some of the invoices. Please try again later. ', {
                    title: 'Error',
                    solid:true,
                    variant: 'danger',
                    autoHideDelay: 5000,
                    appendToast: false
                    })
            }

        },
        sendInvoicesEmail(uid){
            var mailText = "You have a new invoice from " + this.userProfile.company + '. Please go to Kegseeker to view it.'
            var subject = "New invoice from " + this.userProfile.company
            sendemailsendgriduid(uid,subject, mailText)

            //Get the UID email
            var docRef = fb.usersCollection.doc(uid);
            docRef.get().then(doc => {
            if (doc.exists) {
                if (doc.data().sendOrderEmails){
                    var email = doc.data().email
                    var email1 = doc.data().email1
                    var email2 = doc.data().email2
                    var email3 = doc.data().email3
                    
                    var mailData = {
                        to:email,
                        replyTo:this.currentUser.email,
                        from: this.userProfile.company +" <" + this.currentUser.email+">",
                        message:{
                            subject:"New invoice from " + this.userProfile.company,
                            html:mailText
                        }
                    }
                    fb.emailToEmailCollection.add(mailData)

                    if(email1.length>2){
                        mailData.to=email1
                        mailData.replyTo = email1
                    }
                    fb.emailToEmailCollection.add(mailData)

                    if(email2.length>2){
                        mailData.to=email2
                        mailData.replyTo = email2
                    }
                    fb.emailToEmailCollection.add(mailData)

                    if(email3.length>2){
                        mailData.to=email3
                        mailData.replyTo = email3
                    }
                    fb.emailToEmailCollection.add(mailData)
                    
    
    
                }
            } else {
                // doc.data() will be undefined in this case
                console.log("Could not find user with uid" + uid);
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

        },
    },

    mounted(){
        this.invoicedOrders= JSON.parse(JSON.stringify(this.invoicesArray))
    },
}
</script>

<style scoped>
    .hr2 { 
        position: relative; 
        top: 20px; 
        border: none; 
        height: 12px; 
        background: black; 
        margin-bottom: 50px; 
    } 
    .form-control {
        border: 0;
    }
</style>

